var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.getStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }